<template>
  <div class="get-address">
    <div class="form-div">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="90px">
        <el-form-item label="收货人:" prop="consignee">
          <div class="item-div">
            <el-input v-model="ruleForm.consignee"/>
          </div>
        </el-form-item>
        <el-form-item label="所在地区:" prop="area">
          <div class="item-div">
            <el-cascader
              ref="cascaderAddr"
              size="large"
              width="300px"
              :options="options"
              v-model="ruleForm.attribute1"
              @change="handleChange"
            >
            </el-cascader>
<!--            <el-input v-model="ruleForm.area"/>-->
          </div>
        </el-form-item>
        <el-form-item label="详细地址:" prop="address">
          <div class="item-div">
            <el-input v-model="ruleForm.address"/>
          </div>
        </el-form-item>
        <el-form-item label="手机号:" prop="tel">
          <div class="item-div">
            <el-input maxlength="11" v-model="ruleForm.tel"/>
          </div>
        </el-form-item>
        <el-form-item label="固定电话:" prop="fixedTel">
          <div class="item-div">
            <el-input maxlength="13" v-model="ruleForm.fixedTel"/>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div class="modal-btn2 active mg-auto" @click="addSubmit" style="cursor: pointer">
      <span>确认修改</span>
    </div>
  </div>
</template>

<script>
import { doUpdateAddress } from '@/api/personCenter/addressInfo/addressL'
import { regionData } from 'element-china-area-data'
export default {
  props: {
    edit: Boolean,
    ruleForm: {
      type: Object,
      default: function () {
        return {}
      }
    },
    isDefault: Boolean
  },
  methods: {
    handleChange (e) {
      this.ruleForm.area = this.$refs.cascaderAddr.getCheckedNodes()[0].pathLabels
      var areaName = this.ruleForm.area
      this.ruleForm.area = ''
      for (var i = 0; i < areaName.length; i++) {
        if (i !== areaName.length - 1) {
          this.ruleForm.area += areaName[i] + '/'
        } else {
          this.ruleForm.area += areaName[i]
        }
      }
      /* areaName.forEach(ele => {
        this.ruleForm.area += ele
      }) */
    },
    addSubmit () {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          doUpdateAddress(this.ruleForm).then(() => {
            this.$emit('closeModal3', false)
          })
        } else {
          return false
        }
      })
    }
  },
  data () {
    return {
      visible4: false,
      options: regionData,
      rules: {
        consignee: [
          { required: true, message: '请输入收货人姓名', trigger: 'change' }
        ],
        area: [
          { required: true, message: '请输入所在地区', trigger: 'change' }
        ],
        address: [
          { required: true, message: '请输入详细地址', trigger: 'change' }
        ],
        // fixedTel: [
        //   { required: true, message: '请输入固定电话', trigger: 'change' } // pattern: /^1[0-9]{10}$/ message: '格式不正确'
        // ],
        tel: [
          { required: true, pattern: /^1[0-9]{10}$/, message: '格式不正确', trigger: 'change' }
        ]
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.get-address {
  padding: 40px 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.form-div {
  margin-left: 80px;
}
.item-div {
  width: 342px;
  position: relative;
  display: flex;
}
.mg-auto {
  margin: 30px auto;
}
.invoice-content {
  display: flex;
  align-items: center;
  .btn {
    width: 166px;
    height: 40px;
    border: 1px solid #E1E1E1;
    border-radius: 2px;
    line-height: 40px;
    text-align: center;
    color: #333333;
    font-size: 14px;
    &.active {
      border-color: #ef922e;
      color: #ef922e;
    }
  }
.sp2:hover{
    cursor: pointer;
    color: #409EFF;
}
}
</style>
